import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
import _imports_0 from '@/assets/icon/check-disabled.png';
const _hoisted_1 = {
  class: "order-initiate"
};
const _hoisted_2 = {
  class: "main-wrap"
};
const _hoisted_3 = {
  class: "header-bar"
};
const _hoisted_4 = {
  class: "route-info"
};
const _hoisted_5 = {
  class: "left"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "dot start-dot"
}, null, -1);
const _hoisted_7 = {
  class: "address"
};
const _hoisted_8 = {
  class: "right"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "dot end-dot"
}, null, -1);
const _hoisted_10 = {
  class: "address"
};
const _hoisted_11 = {
  class: "mapContainer"
};
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  id: "map"
}, null, -1);
const _hoisted_13 = {
  class: "map-button"
};
const _hoisted_14 = {
  key: 0,
  class: "button left-button"
};
const _hoisted_15 = {
  class: "bottom-wrap"
};
const _hoisted_16 = {
  class: "bottom-main"
};
const _hoisted_17 = {
  class: "card-bold itinerary-info"
};
const _hoisted_18 = {
  class: "card-bold bold vehicle-type-list"
};
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "选择车型", -1);
const _hoisted_20 = {
  class: "vehicle-type-data"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = ["src"];
const _hoisted_23 = {
  class: "info"
};
const _hoisted_24 = {
  class: "name"
};
const _hoisted_25 = {
  key: 0,
  style: {
    "margin-left": "2px",
    "display": "inline-block",
    "background": "orangered",
    "color": "#ffffff",
    "border-radius": "4px",
    "font-size": "13px",
    "padding": "1px 5px"
  }
};
const _hoisted_26 = {
  class: "description"
};
const _hoisted_27 = {
  key: 0,
  class: "price"
};
const _hoisted_28 = {
  class: "amount"
};
const _hoisted_29 = {
  key: 0,
  class: "tolls"
};
const _hoisted_30 = {
  key: 1,
  class: "price",
  style: {
    "font-size": "12px",
    "color": "#ccc"
  }
};
const _hoisted_31 = ["src", "onClick"];
const _hoisted_32 = {
  key: 3,
  class: "checkbox",
  src: _imports_0
};
const _hoisted_33 = {
  key: 0,
  class: "card call-preference"
};
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", {
  class: "separate"
}, null, -1);
const _hoisted_35 = {
  class: "card order-form"
};
const _hoisted_36 = {
  key: 0,
  class: "options"
};
const _hoisted_37 = {
  key: 0
};
const _hoisted_38 = {
  key: 0
};
const _hoisted_39 = {
  key: 1
};
const _hoisted_40 = /*#__PURE__*/_createElementVNode("strong", null, "明天", -1);
const _hoisted_41 = {
  key: 2
};
const _hoisted_42 = /*#__PURE__*/_createElementVNode("strong", null, "后天", -1);
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", {
  class: "separate"
}, null, -1);
const _hoisted_44 = {
  key: 0
};
const _hoisted_45 = {
  key: 1
};
const _hoisted_46 = /*#__PURE__*/_createElementVNode("u", null, "代人叫车", -1);
const _hoisted_47 = [_hoisted_46];
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", {
  class: "separate"
}, null, -1);
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", null, "偏好设置", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_button = _resolveComponent("van-button");
  const _component_reserve_form = _resolveComponent("reserve-form");
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_tip_form = _resolveComponent("tip-form");
  const _component_proxy_form = _resolveComponent("proxy-form");
  const _directive_height_animate = _resolveDirective("height-animate");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    class: "button back-button",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goBack && $options.goBack(...args))
  }, [_createVNode(_component_van_icon, {
    name: "arrow-left",
    color: "#333"
  })]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, _toDisplayString($setup.startAddress), 1)]), _createVNode(_component_van_icon, {
    class: "line",
    name: "down"
  }), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, _toDisplayString($setup.endAddress), 1)])])]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_13, [false ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_component_van_icon, {
    class: "security",
    name: require('@/assets/icon/security.svg')
  }, null, 8, ["name"])])) : _createCommentVNode("", true), false ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "button right-button",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.getCurrentPosition && $options.getCurrentPosition(...args))
  }, [_createVNode(_component_van_icon, {
    name: require('@/assets/icon/map/aim.svg')
  }, null, 8, ["name"])])) : _createCommentVNode("", true)])]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(_component_van_icon, {
    name: require('@/assets/icon/map/path.png')
  }, null, 8, ["name"]), _createElementVNode("div", null, [_createTextVNode(" 全程"), _createElementVNode("strong", null, _toDisplayString($options.CommonUtil.formatFloat($setup.kilometer)), 1), _createTextVNode("公里，预计行驶"), _createElementVNode("strong", null, _toDisplayString($options.CommonUtil.formatSeconds($setup.drivingTime)), 1)]), _createVNode(_component_van_icon, {
    class: "link",
    name: "arrow"
  })]), _createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.vehicleTypes, (vehicleType, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass('vehicle-type-item ' + (vehicleType.checked ? 'checked' : '') + (vehicleType.disabled ? ' disabled' : '')),
      key: index,
      onClick: $event => $options.checkVehicleType(index)
    }, [_createElementVNode("img", {
      class: "icon",
      src: vehicleType.icon
    }, null, 8, _hoisted_22), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createTextVNode(_toDisplayString(vehicleType.name), 1), vehicleType.promotions ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(vehicleType.promotionalDiscounts), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_26, _toDisplayString(vehicleType.description), 1)]), !vehicleType.disabled ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createTextVNode(_toDisplayString(vehicleType.pricePrefix) + " ", 1), _createElementVNode("strong", null, _toDisplayString($setup.vehiclePrices[index] ? parseFloat($setup.vehiclePrices[index]).toFixed(2) : '--'), 1), _createTextVNode(" 元 ")]), $setup.tolls && $setup.tolls > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createVNode(_component_van_icon, {
      name: "warning-o"
    }), _createTextVNode(" 包含"), _createElementVNode("strong", null, _toDisplayString(parseFloat($setup.tolls).toFixed(2)), 1), _createTextVNode("元通行费 ")])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_30, " 高峰时期不可用 ")), !vehicleType.disabled ? (_openBlock(), _createElementBlock("img", {
      key: 2,
      class: "checkbox",
      src: vehicleType.checked && !vehicleType.disabled ? require('@/assets/icon/checked.png') : require('@/assets/icon/check.png'),
      onClick: _withModifiers($event => $options.checkVehicleType(index), ["stop"])
    }, null, 8, _hoisted_31)) : _createCommentVNode("", true), vehicleType.disabled ? (_openBlock(), _createElementBlock("img", _hoisted_32)) : _createCommentVNode("", true)], 10, _hoisted_21);
  }), 128))])]), false ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_createElementVNode("div", {
    class: _normalizeClass('preference-item' + ($setup.paidPickUp ? ' selected' : '')),
    onClick: _cache[2] || (_cache[2] = (...args) => $options.selectPaidPickUp && $options.selectPaidPickUp(...args))
  }, [_createVNode(_component_van_icon, {
    name: "underway-o"
  }), _createTextVNode(" 打表来接 ")], 2), _hoisted_34, _createElementVNode("div", {
    class: _normalizeClass('preference-item' + ($setup.tip ? ' selected' : '')),
    onClick: _cache[3] || (_cache[3] = (...args) => $options.clickShowTipForm && $options.clickShowTipForm(...args))
  }, [!$setup.tip ? (_openBlock(), _createBlock(_component_van_icon, {
    key: 0,
    name: require('@/assets/icon/tip/tip.png')
  }, null, 8, ["name"])) : _createCommentVNode("", true), $setup.tip ? (_openBlock(), _createBlock(_component_van_icon, {
    key: 1,
    name: require('@/assets/icon/tip/tip-blod.png')
  }, null, 8, ["name"])) : _createCommentVNode("", true), _createTextVNode("  调度费" + _toDisplayString($setup.tip ? $setup.tipAmount + '元' : ''), 1)], 2)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_35, [false ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createElementVNode("div", {
    class: "item time",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.clickShowReserveForm && $options.clickShowReserveForm(...args))
  }, [!$setup.reserve ? (_openBlock(), _createElementBlock("span", _hoisted_37, "现在出发")) : _createCommentVNode("", true), $setup.reserve ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [$setup.reserveDay === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_38, [_createElementVNode("strong", null, _toDisplayString($setup.reserveTime[0] + ':' + $setup.reserveTime[1]), 1), _createTextVNode("出发")])) : _createCommentVNode("", true), $setup.reserveDay === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_39, [_hoisted_40, _createTextVNode(_toDisplayString($setup.reserveTime[0] + ':' + $setup.reserveTime[1]), 1)])) : _createCommentVNode("", true), $setup.reserveDay === 2 ? (_openBlock(), _createElementBlock("span", _hoisted_41, [_hoisted_42, _createTextVNode(_toDisplayString($setup.reserveTime[0] + ':' + $setup.reserveTime[1]), 1)])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), _createVNode(_component_van_icon, {
    name: "arrow"
  })]), _hoisted_43, _createElementVNode("div", {
    class: "item proxy-call",
    onClick: _cache[5] || (_cache[5] = (...args) => $options.clickShowProxyForm && $options.clickShowProxyForm(...args))
  }, [!$setup.proxy ? (_openBlock(), _createElementBlock("span", _hoisted_44, "代人叫车")) : _createCommentVNode("", true), $setup.proxy ? (_openBlock(), _createElementBlock("span", _hoisted_45, _hoisted_47)) : _createCommentVNode("", true), _createVNode(_component_van_icon, {
    name: "arrow"
  })]), _hoisted_48, _createElementVNode("div", {
    class: "item preference",
    onClick: _cache[6] || (_cache[6] = (...args) => $options.clickRidePreference && $options.clickRidePreference(...args))
  }, [_hoisted_49, _createVNode(_component_van_icon, {
    name: "arrow"
  })])])) : _createCommentVNode("", true), _createVNode(_component_van_button, {
    loading: $setup.calling,
    disabled: $setup.calling || $options.getVehicleType() === -1,
    class: "submit-button",
    type: "primary",
    block: "",
    onClick: $options.submitCall
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.proxy ? '为 TA 叫车' : '立即叫车'), 1)]),
    _: 1
  }, 8, ["loading", "disabled", "onClick"])])])])), [[_directive_height_animate]])]), _createVNode(_component_van_popup, {
    show: $setup.showReserveForm,
    "onUpdate:show": _cache[7] || (_cache[7] = $event => $setup.showReserveForm = $event),
    closeable: "",
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_reserve_form, {
      "reserve-day": $setup.reserveDay,
      "reserve-now-click": $options.reserveNowClick,
      "reserve-enter-click": $options.reserveEnterClick
    }, null, 8, ["reserve-day", "reserve-now-click", "reserve-enter-click"])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.showTipForm,
    "onUpdate:show": _cache[8] || (_cache[8] = $event => $setup.showTipForm = $event),
    closeable: "",
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_tip_form, {
      amount: $setup.tipAmount,
      "cancel-click": $options.tipCancelClick,
      "enter-click": $options.tipEnterClick
    }, null, 8, ["amount", "cancel-click", "enter-click"])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.showProxyForm,
    "onUpdate:show": _cache[9] || (_cache[9] = $event => $setup.showProxyForm = $event),
    closeable: "",
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_proxy_form, {
      "passenger-mobile": $setup.proxyPassengerMobile,
      "passenger-name": $setup.proxyPassengerName,
      "priority-contact-passenger": $setup.proxyPriorityContactPassenger,
      "proxy-self-click": $options.proxySelfClick,
      "proxy-enter-click": $options.proxyEnterClick
    }, null, 8, ["passenger-mobile", "passenger-name", "priority-contact-passenger", "proxy-self-click", "proxy-enter-click"])]),
    _: 1
  }, 8, ["show"])]);
}